import type { ICellRendererParams } from 'ag-grid-community'
import React from 'react'
import PersonCell from 'src/components/List/PersonCell'
import type { GameRosterOfficial } from '../../types'

/** NAME column of the Team Officials grid: avatar + name. */
const OfficialNameCell = ({ data }: ICellRendererParams<GameRosterOfficial>) =>
  data ? <PersonCell item={data} subTitle={undefined} compact /> : null

export default OfficialNameCell
